import { getReportConfig } from '@shared/api/MetricsApi';
import { createReducer, INITIAL_STATE } from '@shared/redux';
import { LOAD_STATE } from '@shared/axios/axios.constants';
import { addCalculatedMetrics } from '@domain/dashboard/metrics-report/metrics-report.utils';
import { GET_SEGMENTS_REQUEST_SUCCEEDED } from '../segments.state';

export const HANDLE_GET_TAG_GROUP_SEGMENTED_REPORT = '@dashboard/tag-groups-segmented/HANDLE_GET_TAG_GROUP_SEGMENTED_REPORT';

export const GET_REPORT_FOR_TAG_GROUP_REQUEST_CALLED = '@dashboard/tag-groups-segmented/GET_REPORT_FOR_TAG_GROUP_REQUEST_CALLED';
export const GET_REPORT_FOR_TAG_GROUP_REQUEST_SUCCEEDED = '@dashboard/tag-groups-segmented/GET_REPORT_FOR_TAG_GROUP_REQUEST_SUCCEEDED';
export const GET_REPORT_FOR_TAG_GROUP_REQUEST_FAILED = '@dashboard/tag-groups-segmented/GET_REPORT_FOR_CUSTOMERS_ID_REQUEST_FAILED';

export const SET_INITIAL_STATE_BY_SLUG = '@dashboard/tag-groups-segmented/SET_INITIAL_STATE_BY_SLUG';
export const CLEAR_SEGMENTED_TAG_GROUP = '@dashboard/tag-groups-segmented/CLEAR_SEGMENTED_TAG_GROUP';

export const handleGetTagGroupSegmentedReport = () => ({
    type: HANDLE_GET_TAG_GROUP_SEGMENTED_REPORT,
    payload: {},
});

export const getTagGroupSegmentedReport = ({
    campaigns,
    conversionType,
    customerId,
    customerType,
    endDate,
    groupSlug,
    segmentation,
    startDate,
    tag,
}) => ({
    type: GET_REPORT_FOR_TAG_GROUP_REQUEST_CALLED,
    actionTypes: {
        success: GET_REPORT_FOR_TAG_GROUP_REQUEST_SUCCEEDED,
        fail: GET_REPORT_FOR_TAG_GROUP_REQUEST_FAILED,
    },
    payload: {
        groupSlug,
        tag,
    },
    config: getReportConfig({
        campaigns,
        conversionType,
        customerId,
        customerType,
        endDate,
        segmentation,
        startDate,
    }),
});

export const setInitialStateSegmentedBySlug = ({ groupSlug }) => ({
    type: SET_INITIAL_STATE_BY_SLUG,
    payload: {
        groupSlug,
    },
});

export const clearSegmentedTagGroup = ({ groupSlug }) => ({
    type: CLEAR_SEGMENTED_TAG_GROUP,
    payload: {
        groupSlug,
    },
});

const initialState = {};

export const tagGroupsSegmentedReportReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [SET_INITIAL_STATE_BY_SLUG]: (state, action) => ({
        ...state,
        [action.payload.groupSlug]: {
            ...state[action.payload.groupSlug],
        },
    }),
    [CLEAR_SEGMENTED_TAG_GROUP]: (state, action) => ({
        ...state,
        [action.payload.groupSlug]: {},
    }),
    [GET_REPORT_FOR_TAG_GROUP_REQUEST_CALLED]: (state, action) => ({
        ...state,
        [action.payload.groupSlug]: {
            ...state[action.payload.groupSlug],
            [action.payload.tag]: {
                loadState: LOAD_STATE.LOADING,
                error: null,
                tag: action.payload.tag,
                data: [],
            },
        },
    }),
    [GET_REPORT_FOR_TAG_GROUP_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        [action.requestAction.payload.groupSlug]: {
            ...state[action.requestAction.payload.groupSlug],
            [action.requestAction.payload.tag]: {
                loadState: LOAD_STATE.SUCCESS,
                ...addCalculatedMetrics(action.payload),
                tag: action.requestAction.payload.tag,
                error: null,
            },
        },
    }),
    [GET_REPORT_FOR_TAG_GROUP_REQUEST_FAILED]: (state, action) => ({
        ...state,
        [action.requestAction.payload.groupSlug]: {
            ...state[action.requestAction.payload.groupSlug],
            [action.requestAction.payload.tag]: {
                loadState: LOAD_STATE.FAIL,
                error: action.payload,
            },
        },
    }),
    [GET_SEGMENTS_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        ...action.payload.data.reduce((acc, tagGroup) => ({
            ...acc,
            [tagGroup.slug]: {},
        }), {}),
    }),
});
